import { Reducer } from 'redux';
import { endReducer } from '../store/Store';
import {
  GetCustomPages, GetFavoritePages,
  GetPageContent,
  initialContentState,
  SetCurrentPageTitle,
  TContentActions,
  TContentState,
} from '../types/Content';

export const contentReducer: Reducer<TContentState, TContentActions> = (
  state = initialContentState,
  action
) => {
  switch (action.type) {
    case GetPageContent.REQUEST:
      return {
        ...state,
        loading: true,
      };

    case GetPageContent.SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.data.menuItem,
      };

    case GetPageContent.FAILED:
      return state;

    case GetCustomPages.REQUEST:
      return {
        ...state,
        loading: true,
      };

    case GetCustomPages.SUCCESS:
      return {
        ...state,
        loading: false,
        customPages: action.payload.data.items,
      };

    case GetCustomPages.FAILED:
      return state;

    case SetCurrentPageTitle.REQUEST:
      return {
        ...state,
        loading: true,
      }
    case SetCurrentPageTitle.SUCCESS:
      if (
        state.currentPageTitle?.title === action.payload.title &&
        state.currentPageTitle?.url === action.payload.url
      ) {
        return state;
      }
      return {
        ...state,
        loading: false,
        currentPageTitle: action.payload,
      };

    case SetCurrentPageTitle.FAILED:
      return state;

    case GetFavoritePages.REQUEST:
      return {
        ...state,
        loading: true,
      };

    case GetFavoritePages.SUCCESS:
      return {
        ...state,
        loading: false,
        favoritePages: action.payload.data.items,
      };

    case GetFavoritePages.FAILED:
      return state;


    default:
      return endReducer(state, action);
  }
};
